import { render, staticRenderFns } from "./IntroductionList.vue?vue&type=template&id=4a74991c&"
import script from "./IntroductionList.vue?vue&type=script&lang=js&"
export * from "./IntroductionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports